import _objectWithoutProperties from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _createClass from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
var _excluded = ["preset"];
// Preset
import { preset as Preset } from '../../presets/default'; // Utilities

import { consoleWarn } from '../../util/console';
import { mergeDeep } from '../../util/helpers';
import { Service } from '../service';
export var Presets = /*#__PURE__*/function (_Service) {
  _inherits(Presets, _Service);
  var _super = _createSuper(Presets);
  function Presets(parentPreset, parent) {
    var _this;
    _classCallCheck(this, Presets);
    _this = _super.call(this); // The default preset

    var defaultPreset = mergeDeep({}, Preset); // The user provided preset

    var userPreset = parent.userPreset; // The user provided global preset

    var _userPreset$preset = userPreset.preset,
      globalPreset = _userPreset$preset === void 0 ? {} : _userPreset$preset,
      preset = _objectWithoutProperties(userPreset, _excluded);
    if (globalPreset.preset != null) {
      consoleWarn('Global presets do not support the **preset** option, it can be safely omitted');
    }
    parent.preset = mergeDeep(mergeDeep(defaultPreset, globalPreset), preset);
    return _this;
  }
  return _createClass(Presets);
}(Service);
Presets.property = 'presets';